import React from 'react';
import './conteiner.scss';

export const MainConteiner = (props) =>{
    return (
        <div style={props.style} className={`main-conteiner ${props.className || ""}`}>
           { props.children }     
        </div>
    )  
}

export const Conteiner = (props) =>{
    return (
        <div style={props.style} className="conteiner">
           { props.children }     
        </div>
    )  
}

export const FlexConteiner = (props) =>{ 
    return (
        <div style={props.style} className={`flex-conteiner ${props.className}`} onMouseEnter={ props.onMouseEnter } onMouseLeave={ props.onMouseLeave } >
           { props.children }     
        </div>
    )  
}

export const Item = (props) =>{
    return (
        <div style={props.style} className={`conteiner-item ${ props.className || "" } `}>
           { props.children }     
        </div>
    )  
}

export const ItemLabel = (props) =>{
    return (
        <div style={props.style} className={`conteiner-item-label ${ props.className || "" } `}>
           { props.children }     
        </div>
    )  
}